class educatorsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/educators/:route',{},{
			getEducators:{
				method:'GET',
				params : {}
			},
			getEnabledEducators:{
				method:'GET',
				params : {
					route : 'enabled-educator'
				}
			},
			getEducatorDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveEducators:{
				method:'POST',
				params : {}
			},
			updateEducators:{
				method:'PUT',
				params : {}
			},
		});

		return {
			services : services
		};
	}
}

educatorsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.educatorsServices', [])
.service('educatorsServices', educatorsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/educators/educatorsServices.js